export enum StakeholderTypeEnum {
  endUser = 'END_USER',
  policyHolder = 'POLICYHOLDER',
  reporter = 'REPORTER',
  person = 'PERSON',
  medicalAdvisor = 'MEDICAL_ADVISOR',
  crisisPsychologist = 'CRISIS_PSYCHOLOGIST',
  dentist = 'DENTIST',
  doctorOutpatientClinic = 'DOCTOR_OUTPATIENT_CLINIC',
  hospital = 'HOSPITAL',
  pharmacy = 'PHARMACY',
  hotel = 'HOTEL',
  airAmbulanceCompany = 'AIR_AMBULANCE_COMPANY',
  airline = 'AIRLINE',
  charterFights = 'CHARTER_FLIGHTS',
  schedulesFights = 'SCHEDULED_FLIGHTS',
  airport = 'AIRPORT',
  ambulanceCompany = 'AMBULANCE_COMPANY',
  taxi = 'TAXI',
  escortDoctor = 'ESCORT_DOCTOR',
  escortNurse = 'ESCORT_NURSE',
  assistanceContact = 'ASSISTANCE_CONTACT',
  billingOfficeAdministration = 'BILLING_OFFICE_ADMINISTRATION',
  sosServiceOffice = 'SOS_SERVICE_OFFICE',
  travelAgency = 'TRAVEL_AGENCY',
  churchesAndPriests = 'CHURCHES_AND_PRIESTS',
  embassyConsulate = 'EMBASSY_CONSULATE',
  funeralCompany = 'FUNERAL_COMPANY',
  lawyers = 'LAWYERS',
  policeAndRescueSearch = 'POLICE_AND_RESCUE_SEARCH',
  shippingAndCargoCompany = 'SHIPPING_AND_CARGO_COMPANY',
  coTraveller = 'COTRAVELLER',
  medicalEscort = 'MEDICALESCORT',
  nonMedicalEscort = 'NON_MEDICAL_ESCORT',
  other = 'OTHER',
  gop = 'GOP',
  patientsDoctorHospital = 'PATIENTS_DOCTOR_HOSPITAL'
}
